<div class="row">
    <div class="col-md-12 col-xl-12">
        <div class="card">
            <div class="card-header b-l-primary border-3">
                <button style="float: right;" type="button" class="btn btn-primary m-r-25" (click)="addNewQRCodeBatch();$event.preventDefault()"><i class="p-r-5 fa fa-plus"></i><span><strong>Add New QRCode Batch</strong></span></button>
            </div>
            <div class="card-body">
                <div style="padding-left:15px;padding-right:15px;">
                    <ngx-datatable
                        class="ngx-datatable content-table bootstrap fixed-header virtualized"
                        [loadingIndicator]="loading"
                        [columnMode]="'force'"
                        [headerHeight]="50"
                        [footerHeight]="50"
                        [rowHeight]="65"
                        [externalPaging]="true"
                        [externalSorting]="true"
                        [count]="page.count"
                        [offset]="page.offset"
                        [limit]="page.limit"
                        [sortType]="'single'"
                        [reorderable]="true"
                        (page)="pageCallback($event)"
                        (sort)="sortCallback($event)"
                        [sorts]="[{prop: 'id', dir: 'desc'}]"
                        (activate)="onActivate($event)"
                        [scrollbarH]="true"
                        [rowClass]="getRowClass"
                        [rows]="items"
                        >
                        <ngx-datatable-column prop="id" name="Sl. No" [width]="10" [resizeable]="false">
                            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                <strong>{{row.id}}</strong>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="batchName" name="Batch Name" [width]="30" [resizeable]="true">
                            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                <strong>{{row.batchName}}</strong>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="numberOfCodes" name="Number Of Codes" [width]="30" [resizeable]="true">
                            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                <strong>{{row.numberOfCodes}}</strong>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="chatBotNumber" name="Chat Bot Number" [width]="30" [resizeable]="true">
                          <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                              <strong>{{row.chatBotNumber}}</strong>
                          </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="product.name" name="Product" [width]="30" [resizeable]="true">
                          <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                              <strong>{{row?.product?.name}}</strong>
                          </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column prop="used" [headerClass]="'text-center'" name="Used For Prinitng" [cellClass]="'icon-center'" [width]="30" [resizeable]="true">
                          <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                            <i *ngIf="row?.used" class="fa fa-check-circle"></i>
                            <i *ngIf="!row?.used" class="icofont icofont-ui-close"></i>
                          </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column style="justify-content: center;" prop="updatedAt" name="Last Updated" [width]="20" [resizeable]="true">
                            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                <strong>{{row.updatedAt}}</strong>
                            </ng-template>
                        </ngx-datatable-column>

                        
                    
                        <ngx-datatable-footer>
                            <ng-template
                              let-rowCount="rowCount"
                              let-pageSize="pageSize"
                              let-selectedCount="selectedCount"
                              let-curPage="curPage"
                              let-offset="offset"
                              ngx-datatable-footer-template
                            >
                            <div class="controls">
                                <div>
                                  <label class="datatable-body-cell-label " for="per-page">
                                    Items Per Page:
                                  </label>
                                  <select
                                    id="items-per-page" 
                                    class="form-control items-per-page"
                                    (change)="onLimitChange($event.target.value)"
                                    [value]="page.limit"
                                    style="display:inline-block;width: 50px;text-align: center;"
                                  >
                                    <option
                                      *ngFor="let option of pageLimitOptions"
                                      [value]="option.value"
                                    >
                                      {{ option.value }}
                                    </option>
                                  </select>
                                </div>
                            </div>
                              <app-datatable-pager
                                (download)="exportAs($event)"
                                [page]="curPage"
                                [visiblePagesCount]="3"
                                [size]="pageSize"
                                [count]="rowCount"
                                [hidden]="false"
                                (showFilter)="openFiltersSection(content)"
                                (clearFilter)="clearFilter()"
                                (change)="onPageChange($event)">
                              </app-datatable-pager>
                            </ng-template>
                          </ngx-datatable-footer>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>
